"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isEqual(a, b) {
    return a === b;
}
exports.config = {
    production: isEqual('false', 'true'),
    hmr: isEqual('false', 'true'),
    services: {
        data: {
            endpoint: 'wss://data.buymyplace.com.au/v1/graphql',
        },
        googleMaps: {
            key: 'AIzaSyC4WdUw_24mHBgG_jrPefVKKHLXFCzh6SA'
        },
        analytics: {
            segment: {
                enabled: isEqual('false', 'true'),
                writeKey: 'pbeELIVuXk7aoLyYmkFSqa94ihV1jxST',
            },
        },
        sentry: {
            sentryDsnVendor: 'https://c11b9d36e4ae476ca337005b814b4752@o402650.ingest.sentry.io/5569314',
        },
    },
    application: {
        branch: 'bmp-production',
        buildDate: 'Thu, 24 Jul 2025 13:38:24 GMT',
        buildNumber: '20250724_133822',
        version: '0.0.10',
        gitHead: '1b76a05'
    }
};
